import { useIsomorphicLayoutEffect } from './chunk-7BGCISJZ.js';
import { _window } from './chunk-7TUQAXR6.js';
import { useState } from 'react';

function useWindowSize(options) {
  const {
    initialWidth = Infinity,
    initialHeight = Infinity,
    includeScrollbar = true
  } = options ?? {};
  const [width, setWidth] = useState(initialWidth);
  const [height, setHeight] = useState(initialHeight);
  const update = () => {
    if (_window) {
      if (includeScrollbar) {
        setWidth(_window.innerWidth);
        setHeight(_window.innerHeight);
      } else {
        setWidth(_window.document.documentElement.clientWidth);
        setHeight(_window.document.documentElement.clientHeight);
      }
    }
  };
  useIsomorphicLayoutEffect(() => {
    update();
    _window.addEventListener("resize", update, { passive: true });
    return () => _window.removeEventListener("resize", update);
  }, []);
  return { width, height };
}

export { useWindowSize };
